<div style="height: 100%; position: relative;">
  <div class="background1">
    <div></div>
  </div>

  <div style="z-index: 1">
    <app-header (showMenu)="changeMenuState(true)"></app-header>
    <div style="height: 30vh;"></div>
    <app-about-us></app-about-us>
  </div>
  <img src="/assets/img/divider.svg" style="width: 100%; position: relative; top: 1px;">
</div>

<div style="height: 100%; position: relative;">
  <div class="background2">
    <div></div>
  </div>

  <div style="z-index: 1">
    <app-partner></app-partner>
    <app-artists></app-artists>
    <div class="neon-container">
      <p class="neon-lime text-uppercase">Visit us discover our vision</p>
      <p class="neon-lime text-uppercase" aria-hidden="true">Visit us discover our vision</p>
      <p class="neon-lime text-uppercase" aria-hidden="true">Visit us discover our vision</p>
    </div>
  </div>
</div>

<div style="height: 100%; position: relative;">
  <div class="background3">
    <div></div>
  </div>

  <div style="z-index: 1">
    <app-services></app-services>
    <app-faq></app-faq>
    <app-footer></app-footer>
  </div>
</div>

<div id="menu" [style.top]="showMenu ? '0' : '-100dvh'">
  <div class="background-menu">
    <div></div>
    <div></div>
  </div>

  <app-menu (hideMenu)="changeMenuState(false)" (voiceSelect)="scrollTo($event)"></app-menu>
</div>